import instance from "./instance";
import { fetchBranch } from "./store";
import { commitCheckoutV2Context, clearCheckoutV2CartValidation } from "../../checkout-v2/state/actions";

const same = (a, b) => String(a ?? "") === String(b ?? "");
export const resolveProfileAddress = (address, store = {}) => {
  const charge = (store.branch_delivery_charges || []).find(c => same(c.id, address.branch_delivery_charge_id));
  const area = (store.areas || []).find(a => same(a.id, address.area_id));
  const branchId = charge?.branch || charge?.branch_id || address.branch_delivery_charge__branch__id || null;
  const branch = (store.branches || []).find(b => same(b.id, branchId));
  const inactive = value => value && (value.is_deleted === true || value.is_active === false);
  const unavailable = store.settings?.enable_delivery === false || !address.area_id || !address.country_id || inactive(area) ||
    address.area__is_deleted === true || address.area__delivery_charge__is_active === false ||
    address.area__delivery_charge__is_deleted === true ||
    (store.settings?.is_branch_based_ordering && (!branchId || !address.branch_delivery_charge_id ||
      inactive(charge) || inactive(branch) || branch?.enable_delivery === false ||
      (charge?.area_id != null && !same(charge.area_id, address.area_id)) ||
      address.branch_delivery_charge__is_active === false || address.branch_delivery_charge__is_deleted === true ||
      address.branch_delivery_charge__branch__is_deleted === true));
  if (unavailable) throw new Error("address_unavailable");
  return { ...address, branch_delivery_charge__branch__id: branchId };
};

export const postProfile = async (data) => {
  const response = await instance.post("/storefront_profile/", data);
  if (!response.data?.success) throw new Error("profile_save_failed");
  return response.data;
};

// Used by both account management and the checkout address picker. Keep the
// basket intact; the v2 quote validates it against the newly selected branch.
export const selectProfileAddress = (address, { persist = true } = {}) => async (dispatch, getState) => {
  const state = getState();
  const store = state.store.store;
  address = resolveProfileAddress(address, store);
  const checkAccount = () => {
    if (!getState().auth?.user || !same(state.auth?.user?.user_id, getState().auth?.user?.user_id))
      throw new Error("account_changed");
  };
  checkAccount();
  const branchId = store.settings.is_branch_based_ordering ? address.branch_delivery_charge__branch__id : null;
  const changed = `${state.customers?.address?.area}` !== `${address.area_id}` ||
    !same(state.branch?.branch, branchId) || state.branch?.isPickup ||
    (store.settings.is_branch_based_ordering && !same(state.branch?.bdc, address.branch_delivery_charge_id));
  const commit = async () => {
    checkAccount();
    if (persist) await postProfile({ action: "preferred", address_id: address.id });
    checkAccount();
    dispatch({ type: "MAKE_ADDRESS_PREFERRED", payload: address.id });
    if (changed) dispatch({ type: "RESET_DELIVERY_TIME" });
    dispatch(commitCheckoutV2Context({ type: "delivery", countryId: address.country_id, areaId: address.area_id,
      branchId, branchDeliveryChargeId: store.settings.is_branch_based_ordering ? address.branch_delivery_charge_id : null,
      address: { lat: address.lat, lng: address.lng, gpsConfirmed: address.gps_confirmed === true }, time: null }));
    dispatch(clearCheckoutV2CartValidation());
    dispatch({ type: "SWITCH_ADDRESS", payload: { address, isBranchBased: store.settings.is_branch_based_ordering } });
  };
  if (store.settings.is_branch_based_ordering && (changed || state.branch?.addressRefreshRequired)) {
    try {
      await dispatch(fetchBranch("delivery", address.branch_delivery_charge_id, state.cart.cart, state.cart.promos,
        null, null, null, branchId, null, { beforeApply: commit, preserveCart: true, throwOnError: true }));
      dispatch({ type: "SET_BRANCH_DELIVERY_CHARGE", payload: { addressRefreshRequired: false } });
    } catch (error) {
      if (getState().auth?.user && same(state.auth?.user?.user_id, getState().auth?.user?.user_id))
        dispatch({ type: "SET_BRANCH_DELIVERY_CHARGE", payload: { addressRefreshRequired: true } });
      throw error;
    }
  } else await commit();
};
